import styled from "@emotion/styled";

const TeamItems = styled("div")(() => ({
  display: "grid",
  gap: "2rem",
  width: "100%",
  minHeight: 300,
  gridTemplateColumns: "repeat(1, 1fr)",
  "@media (min-width: 768px)": {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  "@media (min-width: 1024px)": {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
}));

export default TeamItems;
